/**
 * CenterContainer parser: Control plus `use_top_left` (`center_container.h:38`).
 * Centring is the solver's concern.
 */
import { parseOptionalBool } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
export function parseCenterContainer(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.useTopLeft = parseOptionalBool(properties.use_top_left);
    return result;
}
//# sourceMappingURL=parser.js.map